import { memo, ReactNode } from 'react';
import { ErrorIcon } from 'src/modules/common/icons/ErrorIcon.tsx';
import clsx from 'clsx';
import { WarningIcon } from 'src/modules/common/icons/WarningIcon.tsx';

type Props = {
    type: 'error' | 'warning';
    message: ReactNode;
}

export const InlineNotification = memo(({ type, message }: Props) => {
    const icon = {
        error: <ErrorIcon/>,
        warning: <WarningIcon/>,
    };

    return (
        <div className={clsx({
            'vss-inline-notification': true,
            [`vss-inline-notification--${type}`]: true,
        })}
        >
            <div className="vss-inline-notification__icon">
                {icon[type]}
            </div>

            <p className="vss-inline-notification__message">
                {message}
            </p>
        </div>
    );
});
